import SuperJSON from "superjson";
import Id from "../types/Id";

export default class DataSourceEntryId extends Id<"dataSourceEntry"> {}

SuperJSON.registerClass(DataSourceEntryId, { identifier: "DataSourceEntryId" });
